// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 850px) {
    .scl--web-page-company-hero-section .scl--web-component-hero-content{
        padding-left: var(--global-tablet-padding-left);
    }

    .scl--web-page-company-hero-section .scl--web-component-hero-content button{
        width: 319px;
        height: 60px;
        border-radius: 30px;
    }

    .scl--web-page-company-hero-section .scl--web-component-hero-content button span{
        font-size: 24px;
    }

    .scl--web-page-company-hero-section .scl--web-component-hero-title span{
        font-size: 90px;
    }

     .scl--web-page-company-gradient-overlay{
        width: 100%;
    }

    .scl--web-page-company-hero-section .scl--conic-com-spotlight{
        width: 50%;
    }

    .scl--wpcovs-cons-resp-str{
        max-width: var(--global-tablet-width-resp);
    }

    .scl--wpcovs-se-con-str .scl--stv-con-bo-str{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wpcovs-se-con-str{
        padding-bottom: 50px;
    }

    .scl--web-page-company-hero-section .scl--web-component-hero-title{
        line-height: normal;
        letter-spacing: 0px;
    }

    .scl--stv-con-bo-str .scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{
        width: 80%;
        font-size: 28px;
        line-height: 30px;
    }
    
    .scl--wpcops-bo-cont-str-compl{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wdacs-st-cont-bo-st{
        grid-template-columns: repeat(1, minmax(311px, 1fr));
    }

    .scl--wpcops-con-sec-str .scl--web-component-section-title-text-container{
        padding-top: 90px;
    }

    .scl--wdacs-bo-car-con-st{
        min-height: 370px;
        padding-bottom: 30px;
    }

    .scl--wpcops-dc-art-con-str{
        margin-top: 50px;
    }

    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str{
        flex-direction: column;
    }

    .scl--web-page-company-our-value-section .scl--scbs-sec-ti-con-bo-str{
        flex-direction: column;
    }

    .scl--wpds-resp-con-stl{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str{
        width: 75%;
    }

    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str h6{
        font-size: 40px;
    }

    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str p{
        font-size: 28px;
        line-height: 30px;
    }

    .scl--wpcops-con-sec-str .scl--web-component-section-description-container{
        width: 80%;
    }

    .scl--mai-com-bx-cont-st .scl--web-component-section-description-text{
        font-size: 28px;
        line-height: 30px;
    }

    .scl--wtcs-ti-con-st{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wtcs-nea-fo-lin-dcl-st{
        gap: 45px;
    }

    .scl--step-comp-box-cont-stl{
        width: 100%;
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wpchs-tal-con-str{
        min-height: 2000px;
        padding-bottom: 95px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-list-container .scl--web-component-talent-step-item{
        display: flex;
        flex-direction: column;
        gap: 35px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-list-container{
        gap: 35px;
    }
    
    .scl--step-comp-box-cont-stl .scl--web-component-talent-content{
        width: 100%;
        gap: 30px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-content button{
        width: 336px;
        height: 60px;
        border-radius: 30px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-content button svg{
        width: 20px;
        height: 20px;
        margin-top: 3px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-content button .scl--web-component-talent-button-text{
        font-size: 28px;
        line-height: normal;

    }

     .scl--step-comp-box-cont-stl .scl--web-component-talent-description{
        font-size: 28px;
        width: 80%;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-title {
        font-size: 40px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-step-number{
        font-size: 18px;
    }

    .scl--wpcs-cont-stl-bo{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wpctas-dc-art-con-str .scl--web-component-contact-card-description{
        font-size: 28px;
        line-height: 30px;
    }

    .scl--wpctas-dc-art-con-str{
        margin-top: 100px;
    }

    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st:not(:last-child){
        border-right: none;
    }

    .scl--web-page-ctac-section .scl--web-component-section-title-text-container{
        margin-top: 85px;
    }

    .scl--web-page-ctac-section .scl--web-component-section-description-container{
        margin-top: 30px;
    }

    .scl--web-page-company-our-principle-section{
        padding-bottom: 38px;
    }

    .scl--web-page-differ-section{
        padding-bottom: 38px;
    }

    .scl--web-page-differ-section .scl--wpcops-dc-art-con-str .scl--wdacs-st-cont-bo-st{
        grid-template-columns: repeat(1, minmax(150px, 1fr));
    }

    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str.border-right, .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str.border-left{
        border: none;
        padding: 0px;
    }

    .scl--wpctas-st-cont-bo-st{
        grid-template-columns: repeat(1, minmax(100px, 1fr));
    }

    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-styled-button{
        width: 358px;
        height: 60px;
        border-radius: 30px;
        border: 1.5px solid rgba(121, 121, 121, 1);
        background: rgba(40, 40, 40, 1);
    }

    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-styled-button span{
        font-size: 24px;
        width: auto;
    }

    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st:last-child .scl--web-component-contact-styled-button{
        background-color: transparent;
    }

    .scl--web-page-ctac-section .scl--web-component-section-title-text{
        font-size: 70px;
    }

    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-title{
        font-size: 40px;
    }

    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-content-wrapper{
        width: 100%;
        max-width: none;
    }

    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dcbs-st-con-str{
        gap: 85px;
    }

}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/company/css/companySt.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;IACnD;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;KAEC;QACG,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;;IAEvB;;KAEC;QACG,eAAe;QACf,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,0CAA0C;QAC1C,+BAA+B;IACnC;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;AAEJ","sourcesContent":["@media (max-width: 850px) {\n    .scl--web-page-company-hero-section .scl--web-component-hero-content{\n        padding-left: var(--global-tablet-padding-left);\n    }\n\n    .scl--web-page-company-hero-section .scl--web-component-hero-content button{\n        width: 319px;\n        height: 60px;\n        border-radius: 30px;\n    }\n\n    .scl--web-page-company-hero-section .scl--web-component-hero-content button span{\n        font-size: 24px;\n    }\n\n    .scl--web-page-company-hero-section .scl--web-component-hero-title span{\n        font-size: 90px;\n    }\n\n     .scl--web-page-company-gradient-overlay{\n        width: 100%;\n    }\n\n    .scl--web-page-company-hero-section .scl--conic-com-spotlight{\n        width: 50%;\n    }\n\n    .scl--wpcovs-cons-resp-str{\n        max-width: var(--global-tablet-width-resp);\n    }\n\n    .scl--wpcovs-se-con-str .scl--stv-con-bo-str{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wpcovs-se-con-str{\n        padding-bottom: 50px;\n    }\n\n    .scl--web-page-company-hero-section .scl--web-component-hero-title{\n        line-height: normal;\n        letter-spacing: 0px;\n    }\n\n    .scl--stv-con-bo-str .scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{\n        width: 80%;\n        font-size: 28px;\n        line-height: 30px;\n    }\n    \n    .scl--wpcops-bo-cont-str-compl{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wdacs-st-cont-bo-st{\n        grid-template-columns: repeat(1, minmax(311px, 1fr));\n    }\n\n    .scl--wpcops-con-sec-str .scl--web-component-section-title-text-container{\n        padding-top: 90px;\n    }\n\n    .scl--wdacs-bo-car-con-st{\n        min-height: 370px;\n        padding-bottom: 30px;\n    }\n\n    .scl--wpcops-dc-art-con-str{\n        margin-top: 50px;\n    }\n\n    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str{\n        flex-direction: column;\n    }\n\n    .scl--web-page-company-our-value-section .scl--scbs-sec-ti-con-bo-str{\n        flex-direction: column;\n    }\n\n    .scl--wpds-resp-con-stl{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str{\n        width: 75%;\n    }\n\n    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str h6{\n        font-size: 40px;\n    }\n\n    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str p{\n        font-size: 28px;\n        line-height: 30px;\n    }\n\n    .scl--wpcops-con-sec-str .scl--web-component-section-description-container{\n        width: 80%;\n    }\n\n    .scl--mai-com-bx-cont-st .scl--web-component-section-description-text{\n        font-size: 28px;\n        line-height: 30px;\n    }\n\n    .scl--wtcs-ti-con-st{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wtcs-nea-fo-lin-dcl-st{\n        gap: 45px;\n    }\n\n    .scl--step-comp-box-cont-stl{\n        width: 100%;\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wpchs-tal-con-str{\n        min-height: 2000px;\n        padding-bottom: 95px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-list-container .scl--web-component-talent-step-item{\n        display: flex;\n        flex-direction: column;\n        gap: 35px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-list-container{\n        gap: 35px;\n    }\n    \n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content{\n        width: 100%;\n        gap: 30px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content button{\n        width: 336px;\n        height: 60px;\n        border-radius: 30px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content button svg{\n        width: 20px;\n        height: 20px;\n        margin-top: 3px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content button .scl--web-component-talent-button-text{\n        font-size: 28px;\n        line-height: normal;\n\n    }\n\n     .scl--step-comp-box-cont-stl .scl--web-component-talent-description{\n        font-size: 28px;\n        width: 80%;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-title {\n        font-size: 40px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-step-number{\n        font-size: 18px;\n    }\n\n    .scl--wpcs-cont-stl-bo{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wpctas-dc-art-con-str .scl--web-component-contact-card-description{\n        font-size: 28px;\n        line-height: 30px;\n    }\n\n    .scl--wpctas-dc-art-con-str{\n        margin-top: 100px;\n    }\n\n    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st:not(:last-child){\n        border-right: none;\n    }\n\n    .scl--web-page-ctac-section .scl--web-component-section-title-text-container{\n        margin-top: 85px;\n    }\n\n    .scl--web-page-ctac-section .scl--web-component-section-description-container{\n        margin-top: 30px;\n    }\n\n    .scl--web-page-company-our-principle-section{\n        padding-bottom: 38px;\n    }\n\n    .scl--web-page-differ-section{\n        padding-bottom: 38px;\n    }\n\n    .scl--web-page-differ-section .scl--wpcops-dc-art-con-str .scl--wdacs-st-cont-bo-st{\n        grid-template-columns: repeat(1, minmax(150px, 1fr));\n    }\n\n    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str.border-right, .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str.border-left{\n        border: none;\n        padding: 0px;\n    }\n\n    .scl--wpctas-st-cont-bo-st{\n        grid-template-columns: repeat(1, minmax(100px, 1fr));\n    }\n\n    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-styled-button{\n        width: 358px;\n        height: 60px;\n        border-radius: 30px;\n        border: 1.5px solid rgba(121, 121, 121, 1);\n        background: rgba(40, 40, 40, 1);\n    }\n\n    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-styled-button span{\n        font-size: 24px;\n        width: auto;\n    }\n\n    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st:last-child .scl--web-component-contact-styled-button{\n        background-color: transparent;\n    }\n\n    .scl--web-page-ctac-section .scl--web-component-section-title-text{\n        font-size: 70px;\n    }\n\n    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-title{\n        font-size: 40px;\n    }\n\n    .scl--wpctas-st-cont-bo-st .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-content-wrapper{\n        width: 100%;\n        max-width: none;\n    }\n\n    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dcbs-st-con-str{\n        gap: 85px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
